"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerticalStackComponent = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
const _excluded = ["spacing", "width", "height", "bg", "borderRadius", "justifyContent", "alignItems"];
const VerticalStackComponent = exports.VerticalStackComponent = _styledComponents.default.div`
	${_ref => {
  let {
      spacing,
      width,
      height,
      bg,
      borderRadius,
      justifyContent,
      alignItems
    } = _ref,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return `
    gap: ${spacing}; 
    width: ${width};
    height: ${height}; 
    background: ${bg}; 
    border-radius: ${borderRadius};
    justify-content: ${justifyContent};
    align-items: ${alignItems};
`;
}}
`;